export const contactsData = {
    email: 'muhammadhamzahaneef@gmail.com',
    phone: '+92 3138148825',
    address: 'House # 49/1, Area 2-b Landhi, Karachi Pakistan',
    sheetAPI: ''
}